import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "../action/annoucement";
import * as types  from "../../types/annoucement";

type initialState = {
    annoucements: types.annoucement[]
}

const annoucementSlider = createSlice({
    name: "annoucement",
    initialState: {
        annoucements: []
    } as initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(actions.getAnnoucement.fulfilled, (state, action) => {
                state.annoucements = action.payload
            })
            .addCase(actions.clearAnnoucement, (state, action) => {
                state.annoucements = []
            })
    }
})

export const {  } = annoucementSlider.actions
export default annoucementSlider.reducer